module.exports = __webpack_public_path__ + "static/media/process-2.ddb1cb88.svg";